import { render, staticRenderFns } from "./RefundPatient.vue?vue&type=template&id=40bcda90&scoped=true"
import script from "./RefundPatient.vue?vue&type=script&lang=js"
export * from "./RefundPatient.vue?vue&type=script&lang=js"
import style0 from "./RefundPatient.vue?vue&type=style&index=0&id=40bcda90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcda90",
  null
  
)

export default component.exports